import React from 'react';
import PropTypes from 'prop-types';
import styles from './options.scss';

class OptionsGroup extends React.PureComponent {
    static propTypes = {
        buttons: PropTypes.array.isRequired,
    };

    render() {
        if (this.props.buttons.length === 0) {
            return null;
        }

        return <div className={styles.buttonGroup}>{this.props.buttons}</div>;
    }
}

export default OptionsGroup;
